module.exports = __webpack_public_path__ + "static/img/B (13).e0bfb040.png";